import { DASHBOARD_STEPS_FORM_LOADER } from "./dashboard_steps_form_loader";

export const DASHBOARD_STEPS_NEW_LOADER = DASHBOARD_STEPS_FORM_LOADER;
